
<h2 mat-dialog-title>Create a Rebalance<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></h2>
<mat-dialog-content class="mat-badge-medium">
  @if (allowRebalanceSubmit) {
    <div>
      <span>{{data.message}}</span>
    </div>
  }
  <div style="display: flex; padding: 3px;">
    <label>Rebalance Type:</label>
    <irb-dropdown-filter #IrbSelectedRebalanceTypeDropdown
      id="irbSelectedRebalanceTypeDropdown"
      size="31"
      hoverPanelWidth="275"
      [value]="selectedRebalanceType.value"
      (search)="setChainTypeOptions($event)"
      (selection)="selectOption($event)"
    ></irb-dropdown-filter>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close class="btn-medium-secondary">Cancel</button>
  @if (allowRebalanceSubmit && !selectedRebalanceType.value.value.disableEditParameters) {
    <button style="position: relative;"
      [ngClass]="{'btn-medium-secondary': !allowOnlyRebalanceSetUp, 'btn-medium-primary': allowOnlyRebalanceSetUp}" [mat-dialog-close]="true"
      (click)="navigateToCreateRebalToEditParams()">Edit Parameters
      @if (selectedRebalanceType.value.value.disableEditParameters) {
<div style="position:absolute;left:15px; top:0;z-index: 1000; width: 130px;
    height: 22px" tooltip [tooltipPosition]="'bottom'" [tooltipWidth]='225' [tooltipVerticalOffset] = '12' 
        [tooltipHorizontalOffset] = '17'  [tooltipTitle]="'Activate &quot;Edit Parameters&quot; by first select a Rebalance Type'"></div>
      }
    </button>
  }

  @if (allowRebalanceSubmit && selectedRebalanceType.value.value.disableContinue) {
    <button style="position: relative;"
      class="btn-medium-primary"  mat-button [mat-dialog-close]="true" (click)="navigateToCreateRebalToEditParams()">Continue
    </button>
  }

  @if (!allowOnlyRebalanceSetUp && (allowRebalanceSubmit && !selectedRebalanceType.value.value.disableSubmit)) {
    <button  style="position: relative;" mat-button class="btn-medium-primary" [mat-dialog-close]="true"
      (click)="createEditSubmitRebalance('submit')" disabled="{{selectedRebalanceType.value.value.disableSubmit}}" cdkFocusInitial>Submit
      @if (selectedRebalanceType.value.value.disableSubmit) {
        <div style="position:absolute;left:0px;top:0;z-index: 1000; width: 90px; height: 22px"
          tooltip [tooltipPosition]="'bottom'" [tooltipWidth]='225' [tooltipVerticalOffset] = '12'
        [tooltipHorizontalOffset] = '25' [tooltipTitle]="'Activate &quot;Submit&quot; by first select a Rebalance Type'"></div>
      }
    </button>
  }


  @if (!allowRebalanceSubmit) {
    <button  style="position: relative;" mat-button class="btn-medium-primary" [mat-dialog-close]="true"
    (click)="createNewRebalances()"  cdkFocusInitial>Continue</button>
  }
</mat-dialog-actions>
